import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DirectionsCarFilledIcon(props: IconProps) {
    return <Icon {...props} iconKey={"directions_car_filled"}/>
}
